import { Trans } from 'react-i18next'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { ComponentSettingKey } from '@/shared/builder'

import { CompAccordionWrapperCore } from '../core/accordion/wrapper'
import { CompAccordion } from './CompAccordion'

/**
 * CompAccordionWrapper
 */
const CompAccordionWrapper = () => {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // tableData
  const { dbClient, tablesMap } = useDbClientContext()
  const tableId = compContext.settings[ComponentSettingKey.AccordionDataSource]
  const table = tableId ? tablesMap.get(tableId) : undefined

  // todo: error state
  if (!table || !dbClient) {
    return (
      <div className='flex justify-center items-center py-8'>
        <Trans>COMP_TABLE_NOT_FOUND</Trans>
      </div>
    )
  }

  return (
    <CompAccordionWrapperCore infos={infosProps} tableData={{ dbTable: table, dbClient, tableId }}>
      {(props) => <CompAccordion {...props} />}
    </CompAccordionWrapperCore>
  )
}

export default CompAccordionWrapper
